// // import Marquee from "react-fast-marquee";
// import apex from '../../../../assets/images/apex.png'
// import bata from '../../../../assets/images/bata.png'
// import Title from "../../../sharedComponents/title/Title";

// const Partners = () => {
//     return (
//         <div className="mb-16 mt-20">
//             <Title heading={'Our Partners'} />
//             {/* <Marquee> */}
//             <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 px-16">
//                 <div className="mx-8">
//                     <img src={apex} alt="" className="w-[250px] h-[100px]" />
//                 </div>
//                 <div className="mx-8">
//                     <img src={bata} alt="" className="w-[250px] h-[100px]" />
//                 </div>
//                 <div className="mx-8">
//                     <img src={apex} alt="" className="w-[250px] h-[100px]" />
//                 </div>
//                 <div className="mx-8">
//                     <img src={bata} alt="" className="w-[250px] h-[100px]" />
//                 </div>
//                 <div className="mx-8">
//                     <img src={apex} alt="" className="w-[250px] h-[100px]" />
//                 </div>
//                 <div className="mx-8">
//                     <img src={bata} alt="" className="w-[250px] h-[100px]" />
//                 </div>
//                 <div className="mx-8">
//                     <img src={apex} alt="" className="w-[250px] h-[100px]" />
//                 </div>
//                 <div className="mx-8">
//                     <img src={bata} alt="" className="w-[250px] h-[100px]" />
//                 </div>
//             </div>
//             {/* </Marquee> */}
//         </div>
//     );
// };

// export default Partners;


import apex from '../../../../assets/images/apex.png';
import bata from '../../../../assets/images/bata.png';
import Arong from '../../../../assets/images/Arong.png';
import Walton from '../../../../assets/images/Walton.png';
import Title from "../../../sharedComponents/title/Title";

const partners = [
  { src: apex, name: 'apex' },
  { src: bata, name: 'bata' },
  { src: Arong, name: 'arong' },
  { src: Walton, name: 'walton' }
];

const Partners = () => {
  return (
    <div className="mb-16 mt-20">
      <Title heading={'Our Partners'} />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 px-8">
        {partners.map(({ src, name }, index) => (
          <div
            key={index}
            className="bg-white shadow-md rounded-2xl flex items-center justify-center p-6 transition hover:shadow-xl"
          >
            <img
              src={src}
              alt={`partner-${name}`}
              className={`object-contain
                ${name === 'arong' || name === 'walton' ? 'w-[280px] h-[120px]' : 'w-[200px] h-[80px]'}
              `}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Partners;

